import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Center } from '../../../../../core/center/center.model';
import { MatTableDataSource, MatPaginator, MatSort, MatDialog, MatDialogConfig } from '@angular/material';
import { Subscription } from 'rxjs';
import { CenterService } from '../../../../../core/center/center.service';
import { LayoutUtilsService, MessageType } from '../../../../../core/_base/crud/utils/layout-utils.service';
import { UserEditComponent } from '../../../user-management/users/user-edit/user-edit.component';
import { CenterEditComponent } from '../../../training-center-management/center-edit/center-edit/center-edit.component';
import { VacanciesService } from '../../../../../core/vacancy/vacancies.service';
import { EditPostingComponent } from '../edit-posting/edit-posting.component';
import { RepostOfficerComponent } from '../repost-officer/repost-officer.component';
import { OfficerDetailsComponent } from '../officer-details/officer-details.component';
// import { CenterEditComponent } from '../../../.center-edit/center-edit/center-edit.component';
import Swal from 'sweetalert2'
import { Posting } from '../../../../../core/vacancy/posting.model';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { AuthService } from '../../../../../core/auth/_services/auth.service';
@Component({
	selector: 'kt-pending-reset',
	templateUrl: './pending-reset.component.html',
	styleUrls: ['./pending-reset.component.scss']
})
export class PendingResetComponent implements OnInit {
	searchKey: string;
	profileDetails: any;
	history: any;
	searchFolio: string;
	@BlockUI() blockUI: NgBlockUI;
	// Table fields

	listData: MatTableDataSource<Center>;

	displayedColumns = ['dateCreated','folioNumber', 'centerName', 'reason', 'requestBy', 'actions'];

	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	@ViewChild('sort1', { static: true }) sort: MatSort;
	// Filter fields
	@ViewChild('searchInput', { static: true }) searchInput: ElementRef;

	// Subscriptions
	private subscriptions: Subscription[] = [];


	constructor(
		private centerService: CenterService,
		private vacancyService: VacanciesService,
		private layoutUtilsService: LayoutUtilsService,
		private authService: AuthService,
		private dialog: MatDialog
	) { }

	ngOnInit() {

		// load allusers 
		this.getAllPendingRequests()
		this.profileDetails = this.getProfileDetails()
		//alert(JSON.stringify(this.profileDetails))

	}

	/**
	 * On Destroy
	 */
	ngOnDestroy() {
		this.subscriptions.forEach(el => el.unsubscribe());
	}

	/**
	 * Load users list
	 */


	/** FILTRATION */
	filterConfiguration(): any {
		const filter: any = {};
		const searchText: string = this.searchInput.nativeElement.value;
		filter.lastName = searchText;
        filter.username = searchText;
		filter.email = searchText;
		filter.fillname = searchText;
		return filter;
	}

	/** ACTIONS */
	/**
	 * Delete user
	 *
	 * @param _item: User
	 */
	deleteUser(_item: Center) {
		const _title = 'Center Delete';
		const _description = 'Are you sure to permanently delete this center?';
		const _waitDesciption = 'Center is deleting...';
		const _deleteMessage = `Center has been deleted`;

		const dialogRef = this.layoutUtilsService.deleteElement(_title, _description, _waitDesciption);
		dialogRef.afterClosed().subscribe(res => {
			if (!res) {
				return;
			}

			//	this.store.dispatch(new UserDeleted({ id: _item.id }));
			this.layoutUtilsService.showActionNotification(_deleteMessage, MessageType.Delete);
		});
	}



	/* UI */
	/**
	 * Returns user roles string
	 *
	 * @param user: User
	 */

	/**
	 * Redirect to edit page
	 *
	 * @param id
	 */
	editUser(id) {

	}
	getAllPendingRequests(folio?) {
		//this.blockUI.start('Fetching records... Please wait')
		this.vacancyService.getPendingResets().subscribe(
			list => {
				let array = list.map(item => {
					return item
				})
				this.listData = new MatTableDataSource(array)

				this.listData.sort = this.sort
				this.listData.paginator = this.paginator
				this.blockUI.stop()

			},error=>{
				this.listData = new MatTableDataSource()
			}
		)

	}
	applyFilter() {

		this.listData.filter = this.searchKey.trim().toLowerCase();
	}
	filterByFolio(){
		let folio = this.searchFolio
		if(folio != undefined){
			this.getAllPendingRequests(folio)

		}
	}
	getProfileDetails() {
		return this.vacancyService.getCurrentUserDetails()
	}
	processRequest(req: any) {
		   
	      
			this.blockUI.start('Processing... please wait')
			
			return this.vacancyService.processPendingResest(req).subscribe(data => {
				this.getAllPendingRequests();
				this.blockUI.stop()

				
				Swal.fire(
					'Processed',
					'Reset successfully processed',
					'success'
				)



			}, error => {
				this.blockUI.stop()
				let err = error.error.message
				
				Swal.fire(
					'Oops! cannot complete the request',
					err,
					'error'
				)

			})
		
	}


	onProcess(req, requestType){
		Swal.fire({
			title: `Are you sure you want to ${requestType} this ?`,
			text: requestType == 'approve'? 'This posting will be canceled for this doctor': 'The officer will remain with the training centre',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: `Yes, ${requestType} ` ,
			cancelButtonText: 'No, Cancel'
		}).then((result) => {
			if (result.value) {
				req.action=requestType
				req.requestId = req.id
				req.reset_without_return = true
				
				this.processRequest(req)

			} else if (result.dismiss === Swal.DismissReason.cancel) {

			}
		})

	}

	

}
